import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { appEnv } from '@/shared/configs/app.config';
import { portalLanguages } from '@/shared/configs/i18n.config';

export function usePortalUrls() {
  const { i18n } = useTranslation();
  const location = useLocation();

  return useMemo(() => {
    const { VITE_APP_URL, VITE_PORTAL_URL, VITE_API_URL } = appEnv;

    const currentUrl = encodeURIComponent(
      new URL(`${location.pathname}${location.search}${location.hash}`, VITE_APP_URL).toString(),
    );

    const portalLng = portalLanguages[i18n.language as keyof typeof portalLanguages] ?? null;

    const withLng = (url: URL) => {
      if (portalLng) {
        url.searchParams.set('lng', portalLng);
      }
      return url.toString();
    };

    const loginUrl = withLng(new URL(`/login?redirectUrl=${currentUrl}`, VITE_PORTAL_URL));
    const logoutUrl = new URL(`/api/logout?redirectUrl=${currentUrl}`, VITE_API_URL).toString();

    const portalUrl = withLng(new URL('/', VITE_PORTAL_URL));

    return { portalUrl, loginUrl, logoutUrl };
  }, [location.pathname, location.search, location.hash, i18n.language]);
}
